/**
 * Lets the visual-evidence harness exercise the real care-team routes with
 * deterministic fixture data before a seeded clinical account is available.
 * This is intentionally limited to development tooling and explicit review
 * query parameters; it cannot affect a production build or normal navigation.
 */
export function isDevCareTeamReview() {
  if (!__DEV__ && process.env.EXPO_PUBLIC_DEV_TOOLS !== "true") {
    return false;
  }

  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);
  return (
    params.get("dev_care_connections") === "1" ||
    (params.get("dev_force_active_cycle") === "true" &&
      params.get("dev_care_connections_cycle") === "1")
  );
}
